import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Clock, Baby, Moon } from 'lucide-react';
export function UniqueMethod() {
  const phases = [{
    title: 'La Pausa Breve',
    description: 'Esperas unos segundos antes de intervenir, adaptado a la edad del bebé.',
    icon: <Clock className="w-6 h-6 text-accent" data-id="element-315" />,
    delay: 0.1
  }, {
    title: 'La Extensión Gradual',
    description: 'Aumentas esas pausas de forma flexible, sin rigidez.',
    icon: <Baby className="w-6 h-6 text-accent" data-id="element-316" />,
    delay: 0.2
  }, {
    title: 'La Consolidación',
    description: 'Ajustas el patrón noche a noche, respetando tu nivel de cansancio.',
    icon: <Moon className="w-6 h-6 text-accent" data-id="element-317" />,
    delay: 0.3
  }];
  return <section className="py-24 bg-brown-dark text-cream relative overflow-hidden rounded-[3rem] mx-4 md:mx-8 my-12" data-id="element-318">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-319">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-accent rounded-full blur-3xl" data-id="element-320"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-brown rounded-full blur-3xl" data-id="element-321"></div>
      </div>

      <div className="max-w-5xl mx-auto px-6 relative z-10" data-id="element-322">
        <FadeIn data-id="element-323">
          <div className="text-center mb-16" data-id="element-324">
            <span className="text-accent font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-325">
              ¿Qué hace diferente este método?
            </span>
            <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-326">
              El Método de Micro-pausas Nocturnas
            </h2>
            <p className="text-xl text-cream/80 max-w-3xl mx-auto font-serif italic" data-id="element-327">
              Te guía en 3 fases simples, adaptadas a tu realidad.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-328">
          {phases.map((phase, index) => <FadeIn key={index} delay={phase.delay} direction="up" data-id="element-329">
              <div className="bg-white/5 border border-white/10 p-8 rounded-3xl backdrop-blur-sm text-center h-full flex flex-col items-center justify-center hover:bg-white/10 transition-colors" data-id="element-330">
                <div className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center mb-6" data-id="element-331">
                  {phase.icon}
                </div>
                <h3 className="text-2xl font-serif font-bold text-accent mb-2" data-id="element-332">
                  Fase {index + 1}
                </h3>
                <p className="text-lg text-cream font-bold mb-2" data-id="element-333">
                  {phase.title}
                </p>
                <p className="text-base text-cream/70" data-id="element-334">{phase.description}</p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-335">
          <div className="bg-white/10 p-8 md:p-10 rounded-3xl backdrop-blur-md border border-white/20" data-id="element-336">
            <p className="text-lg md:text-xl leading-relaxed text-cream/90 text-center" data-id="element-337">
              Este no es un método rígido, es un sistema adaptable para madres
              que necesitan alivio ya.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}